<template>
  <v-dialog v-model="isActive">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-on="on"
        v-bind="attrs"
        color="error"
        class="mx-2"
        icon small
      >
        <v-icon class="cursor-pointer">mdi-delete</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title>
        <span class="headline">刪除統計資料</span>
      </v-card-title>
      <v-card-text>
        <div class="mt-5">
          <v-card-title class="headline justify-center font-weight-bold">是否確認刪除 {{statistic.name}}?</v-card-title>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="dialogbtn cancelBtnColor" @click="close">關閉</v-btn>
        <v-btn class="dialogbtn subBtnColor" @click="confirm">確認</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
export default {
  props: ['statistic'],
  data() {
    return {
      isActive: false,
    }
  },
  methods: {
    confirm() {
      this.$emit('delete', { statistic: this.statistic })
      this.isActive = false
    },
    close() {
      this.name = this.statistic.name
      this.interval = this.statistic.interval
      this.comment = this.statistic.comment
      this.sql = this.statistic.sql 

      this.isActive = false
    }
  }
}
</script>
